<script>

import TheGroupAttestationTable from "./TheGroupAttestationTable.vue";
import axios from "axios";
export default {
  name: "TheGroupAttestation",

  components: {
    TheGroupAttestationTable
  },

  data() {
    return {
      groupsAttestations: [],
      tab: null,
      tabPoint: 0,
      meta: {},
      loading: true,
    };
  },

  mounted() {
    this.getGroupAttestations();
  },

  watch: {
    'tab': function() {
      this.tabPoint = 0;
    }
  },

  computed: {
    groupsList() {
      return this.groupsAttestations || [];
    },

    educationalProgramName() {
      return this.meta?.educationalProgramName || "";
    },

    studyYear() {
      return this.meta?.studyYear;
    },

    attestationPoints() {
      return this.meta?.attestationPoints || [];
    }
  },

  methods: {
    async getGroupAttestations() {
      try {
        const res = await axios.get(`/programms/report/${this.getValueAtIndex(5)}/api/group_attestation`);
        this.groupsAttestations = res.data.groupsAttestations;
        this.meta = res.data.meta;
        this.loading = false;

      } catch (err) {
        console.log(err)
      }
    },

    getValueAtIndex(index){
      const str = window.location.href;
      return str.split("/")[index];
    },
  },
}
</script>

<template>
  <div>
    <v-sheet
      class="d-flex justify-center align-center"
      style="height: 75vh"
      v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="teal darken-3"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
    <v-card v-else flat>

      <v-card-text class="d-flex flex-column">
        <h3 class="font-weight-bold text-h5">
          {{educationalProgramName}}
        </h3>
        <h3 class="font-weight-bold text-h5">
          Учебный год: {{studyYear}}
        </h3>
      </v-card-text>

      <v-tabs
        v-model="tab"
        color="teal darken-3"
      >
        <v-tab
          v-for="group in groupsList"
          :key="group.groupName"
        >
          {{ group.groupName }}
        </v-tab>
      </v-tabs>
      <v-divider/>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="group in groupsList"
          :key="group.groupName"
        >
          <v-card
            flat
          >
            <v-card-text>
              <v-tabs
                v-model="tabPoint"
                color="teal darken-3"
              >
                <v-tab
                  v-for="dateAttestation in group.dateAttestations"
                  :key="dateAttestation.datetime"
                >
                  {{ dateAttestation.datetime }}
                </v-tab>
              </v-tabs>

              <v-divider/>

              <v-tabs-items v-model="tabPoint">
                <v-tab-item
                  v-for="dateAttestation in group.dateAttestations"
                  :key="dateAttestation.datetime"
                >
                  <the-group-attestation-table
                    :group-attestations="dateAttestation.studentAttestations"
                    :group-disciplines="group.disciplines"
                    :tab-point-date="tabPoint"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

    </v-card>
  </div>
</template>

<style scoped>

</style>